// src/userAuth/TestLogin.jsx
//
// Unified login is now used.
// Keep /test-login for old links and open Assessment tab.

import React, {
  useEffect,
} from "react";

export default function TestLogin() {
  useEffect(() => {
    window.location.replace(
      "/login?tab=assessment"
    );
  }, []);

  return null;
}
